import { type Room } from "matrix-js-sdk/src/matrix";

export interface IRoomListCustomisations<Room> {
    /**
     * Determines if a room is visible in the room list or not. By default,
     * all rooms are visible. Where special handling is performed by Element,
     * those rooms will not be able to override their visibility in the room
     * list - Element will make the decision without calling this function.
     *
     * This function should be as fast as possible to avoid slowing down the
     * client.
     * @param room - The room to check the visibility of.
     * @returns True if the room should be visible, false otherwise.
     */
    isRoomVisible?(room: Room): boolean;
}

// Populate this file with the details of your customisations when copying it.

// A real customisation module will define and export one or more of the
// customisation points that make up the interface above.
export const RoomListCustomisations: IRoomListCustomisations<Room> = {};
